import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation } from "swiper/modules";
import { FaPlay } from "react-icons/fa";

const ExpandedModal = ({ isOpen, onClose, data, initialIndex = 0 }) => {
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  useEffect(() => {
    if (isOpen) setActiveIndex(initialIndex);
  }, [isOpen, initialIndex]);

  if (!isOpen) return null;

  const items = [
    ...(data?.pictures || []),
    ...(data?.videos || []).map((v) => ({ video: v.video })),
  ];

  const getEmbedUrl = (url) => {
    if (!url) return "";
    if (url.includes("youtube.com/embed/")) return url;

    const short = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (short) return `https://www.youtube.com/embed/${short[1]}`;

    const long = url.match(/v=([a-zA-Z0-9_-]+)/);
    if (long) return `https://www.youtube.com/embed/${long[1]}`;

    return url;
  };

  return (
    <div
      title="click outside to close"
      className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4 cursor-pointer"
      onClick={onClose}
    >
      <div
        className={`relative rounded-xl shadow-xl ${
          items.length === 1
            ? "bg-white shadow-none w-auto"
            : "bg-white w-full"
        }  max-w-[80vw] xl:max-w-[55vw] max-h-[80vh] xl:max-h-[80vh] 2.5xl:max-h-[90vh] flex flex-col lg:flex-row`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute -top-6 -right-8 text-white text-4xl z-50"
          onClick={onClose}
        >
          &times;
        </button>

        {/* SINGLE ITEM VIEW */}
        {items.length === 1 ? (
          <div className="w-full h-full p-6 flex flex-col items-center justify-center">
            <div className="flex-1 flex items-center justify-center w-full">
              {items[0].image ? (
                <img
                  src={process.env.REACT_APP_BACKEND_URL + "public/" + items[0].image}
                  className="max-w-full max-h-[70vh] object-contain"
                  alt="single"
                />
              ) : (
                <iframe
                  src={getEmbedUrl(items[0].video)}
                  className="w-full h-[70vh] rounded-lg"
                  allowFullScreen
                ></iframe>
              )}
            </div>

            {/* Title at bottom in white */}
            <p className="mt-4 text-center text-md text-dark">
              {data?.title || "Media"}
            </p>
          </div>
        ) : (
          <>
            {/* MULTIPLE ITEMS VIEW */}
            <div className="lg:w-[180px] flex-shrink-0 border-r border-gray flex flex-col">
              <div className="p-4 border-b border-gray">
                <p className="text-sm text-orange">
                  {data?.pictures?.length} Photo(s)
                  {data?.videos?.length > 0 && `, ${data.videos.length} Video(s)`}
                </p>
              </div>

              <div className="flex-1 overflow-auto px-3 py-3">
                <Swiper
                  slidesPerView={5}
                  spaceBetween={10}
                  freeMode
                  watchSlidesProgress
                  direction="horizontal"
                  breakpoints={{
                    1024: { direction: "vertical", slidesPerView: "auto" },
                  }}
                  modules={[FreeMode, Navigation]}
                >
                  {items.map((item, i) => (
                    <SwiperSlide
                      key={i}
                      className={`cursor-pointer rounded-lg border transition-all ${
                        i === activeIndex
                          ? "border-2 border-quaternary"
                          : "border border-gray"
                      }`}
                      onClick={() => setActiveIndex(i)}
                    >
                      <div className="w-full h-[90px] rounded-md overflow-hidden flex items-center justify-center">
                        {item.image ? (
                          <img
                            src={process.env.REACT_APP_BACKEND_URL + "public/" + item.image}
                            alt="thumb"
                            className="w-full h-full object-contain"
                          />
                        ) : (
                          <div className="relative w-full h-full bg-black">
                            <FaPlay className="text-white text-xl absolute inset-0 m-auto" />
                          </div>
                        )}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>

            <div className="flex-1 flex items-center justify-center p-4">
              <div className="w-full h-full flex items-center justify-center bg-gray xl:bg-transparent">
                {items[activeIndex].image ? (
                  <img
                    src={
                      process.env.REACT_APP_BACKEND_URL +
                      "public/" +
                      items[activeIndex].image
                    }
                    className="w-full h-full object-contain"
                    alt="main"
                  />
                ) : (
                  <iframe
                    src={getEmbedUrl(items[activeIndex].video)}
                    title="video-main"
                    className="w-full h-full rounded-lg"
                    allowFullScreen
                  ></iframe>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ExpandedModal;
